import React from 'react';

import classNames from 'classnames';

import { ZERO_DASH } from 'Helpers/formatService';

import LocalisedNumberFormat from 'CommonComponents/LocalisedNumberFormat';

const MINUS = '−';

/**
 * One definition per figure, read by the column headers, the summary cards and
 * the "How these figures are calculated" list alike, so the three cannot drift.
 */
export const COLUMN_DEFINITIONS = {
    budget: { label: 'Budget', definition: 'Rate card items in the project budget at charge-out rates.' },
    cost: { label: 'Cost', definition: 'Budgeted days at rate card cost rates.' },
    budgeted_margin: { label: 'Budgeted margin', definition: 'Budget less cost.' },
    charged: { label: 'Charged', definition: 'Days recorded at charge-out rates.' },
    cost_to_date: { label: 'Cost to date', definition: 'Days recorded at rate card cost rates.' },
    current_margin: { label: 'Current margin', definition: 'Budget less cost to date.' },
    variance: { label: 'Variance to target', definition: 'Current margin less budgeted margin.' },
};

export function projectCount(count) {
    return `${count} ${count === 1 ? 'project' : 'projects'}`;
}

export function hiddenNote(count) {
    return `${projectCount(count)} with no time recorded hidden. Totals include all projects.`;
}

/**
 * Money to the nearest whole unit with a leading minus sign, red when negative,
 * and the dash for a figure the report cannot state. A real zero stays 0: in
 * this report the dash means "cannot be stated", never "nothing".
 */
export function OverviewMoney({ value, negativeClassName = 'tw-text-red' }) {
    if (value === null || value === undefined) {
        return ZERO_DASH;
    }

    const negative = Math.round(value) < 0;

    return (
        <span className={classNames({ [negativeClassName]: negative })}>
            {negative && MINUS}
            <LocalisedNumberFormat value={Math.abs(value)} displayType="text" thousandSeparator={true} decimalScale={0} />
        </span>
    );
}

/** A percentage to one decimal with a leading minus sign, or null when there is none. */
export function formatOverviewPercent(value) {
    if (value === null || value === undefined) {
        return null;
    }

    return `${value < 0 ? MINUS : ''}${Math.abs(Number(value)).toFixed(1)}%`;
}
